import React, { Suspense } from 'react';
import UpgradeSubscriptionPlanModal from './components/stripe/UpgradeSubscriptionPlanModal';
import { useSelector } from 'react-redux';
import { IAllStates } from '../store/rootReducer';

const GlobalModals = () => {
    const { activeModal } = useSelector((state: IAllStates) => state.subscription);

    return (
        <div>
            <Suspense fallback={null}>{activeModal === 'upgrade' && <UpgradeSubscriptionPlanModal />}</Suspense>
        </div>
    );
};

export default GlobalModals;
